import React from 'react';

import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
  NamedLink,
} from '../../components';
import StaticPage from '../../containers/StaticPage/StaticPage';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';

import css from './WhyRotatePage.module.css';
import MarketplaceImage from './images/Marketplace.png';

const WhyRotatePage = () => {
  const { siteTwitterHandle, siteFacebookPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);

  return (
    <StaticPage
      title="About Us"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WhyRotatePage',
        description: 'About Rotate',
        name: 'About page',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.root}>
          <div className={css.sectionSellWrapper}>
            <div className={css.sectionLeft}>
              <h2 className={css.sectionTitle}>More than a marketplace</h2>
              <p>
                ROTATE is a marketplace that’s curated, intentional, and built for
                people who value design. Every piece listed meets standards of quality,
                style and longevity. For buyers, that means browsing considered pieces
                made to last. For sellers, it means knowing their furniture is valued
                by people who appreciate design and craftsmanship.
              </p>
              <p>
                On ROTATE, you will find:
              </p>
              <ul>
                <li>
                  Considered curation — only selected brands are featured, and every
                  vintage piece requires approval. Items are assessed for style, materials,
                  craftsmanship and condition
                </li>
                <li>
                  True value recognised — by connecting each piece with buyers who
                  value design and craftsmanship ROTATE helps maximise its sale price
                  and ensures it finds the right home
                </li>
                <li>
                  Simple, transparent exchange — it’s free to list, with a success
                  fee of only 15% once your item sells. This reflects the care and
                  curation that sets ROTATE apart
                </li>
                <li>
                  Design in circulation — a place for exchange that extends the life
                  of quality pieces
                </li>
              </ul>
              <p>
                ROTATE is more than a marketplace. It’s a way of buying and selling
                with intention — where timeless design keeps moving, from one home
                to the next.
              </p>
            </div>
            <div className={css.sectionRight}>
              <div className={css.imageWithButton}>
                <img src={MarketplaceImage} className={css.howToSell} />
              </div>
            </div>
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage >
  );
};

export default WhyRotatePage;
